<template src="./calendarPage.html"></template>

<script>
import moment from "moment/moment.js"
import menuDialog from "../../components/menuDialog.vue"
import menuHeader from "../../components/menuHeader.vue"
import schoolMealFilters from "../../components/schoolMealFilters.vue"
import adaMixin from "../../js/mixins/adaMixin.js"
import desktopCalendar from "./components/desktopCalendar.vue"
import emptyMenu from "./components/emptyMenu.vue"
import menuItemDetails from "./components/menuItemDetails.vue"
import mobileCalendar from "./components/mobileCalendar.vue"
import printButton from "./components/printButton.vue"
import weekNavigator from "./components/weekNavigator.vue"

    export default {
        name: "calendar-page",
        mixins: [adaMixin],
        components: {
            "print-button": printButton,
            "school-meal-filters": schoolMealFilters,
            "menu-header": menuHeader,
            "menu-dialog": menuDialog,
            "menu-item-details": menuItemDetails,
            "week-navigator": weekNavigator,
            "desktop-calendar": desktopCalendar,
            "mobile-calendar": mobileCalendar,
            "empty-menu": emptyMenu,
        },
        data() {
            return {
                days: [],
                tooltipData: {},
                weeks: [],
                selectedWeek: {},
                selectedWeekIndex: null,
                activeElement: null,
                selectedMenuItem: null,
            }
        },
        computed: {
            siteID() {
                return this.$store.state.PublicMenuModule.siteID
            },
            mealTimeId() {
                return this.$store.state.PublicMenuModule.mealTimeId
            },
            publicMenu() {
                return this.$store.state.PublicMenuModule.publicMenu
            },
            sites() {
                return this.$store.state.PublicMenuModule.sites
            },
            mealTimes() {
                return this.$store.state.PublicMenuModule.mealTimes
            },
            categoriesById() {
                return this.$store.state.PublicMenuModule.categoriesById
            },
            dayMap() {
                let dayMap = []
                for (let i = 0; i < 5; i++) {
                    const week = this.weeks.filter((w) => w.index == this.selectedWeekIndex)[0]
                    if (week) {
                        const day = moment(week.StartDate).add(i, "days")
                        dayMap.push(day.format("dddd, MMM D"))
                    }
                }

                return dayMap
            },
            categories() {
                var categories = {}
                this.days.forEach((day) => {
                    day.DayMenuItems.forEach((item) => {
                        if (!categories[item.CategoryId]) {
                            categories[item.CategoryId] = {
                                CategoryName: item.CategoryName,
                                MenuItemsByDay: {},
                            }
                        }

                        categories[item.CategoryId].MenuItemsByDay[day.DayNumber] = item
                    })
                })

                return categories
            },
        },
        watch: {
            selectedWeekIndex: function () {
                this.searchMenuItems()
            },
            siteID: function () {
                this.getCalendarWeeks()
            },
            mealTimeId: function () {
                this.getCalendarWeeks()
            },
        },
        methods: {
            searchMenuItems() {
                const mealTimeId = this.$store.state.PublicMenuModule.mealTimeId

                if (!mealTimeId)
                    return;

                endpoints
                    .getMenuItemsForCalendarWeek({
                        siteID: this.$store.state.PublicMenuModule.siteID,
                        mealTimeId: this.$store.state.PublicMenuModule.mealTimeId,
                        startDate: this.weeks[this.selectedWeekIndex].StartDate,
                    })
                    .then((response) => {
                        this.days = response
                    })
            },
            openMenuItemDetails(menuItemID) {
                this.selectedMenuItem = this.$store.state.PublicMenuModule.menuItemsById[menuItemID]
                if (this.selectedMenuItem) {
                    this.setAndClearAnnouncement(`Opened details for ${this.selectedMenuItem.DisplayName}`);
                }
            },
            closeTooltip() {
                this.selectedMenuItem = null
            },
            closeDialog() {
                this.setAndClearAnnouncement('Menu item details closed');
                this.selectedMenuItem = null
            },
            goToPreviousWeek() {
                if (this.selectedWeekIndex > 0) {
                    this.selectedWeekIndex--
                    const selectedWeek = this.weeks[this.selectedWeekIndex];
                    if (selectedWeek) {
                        this.setAndClearAnnouncement(`Moved to previous week: ${selectedWeek.DisplayStartDate}`);
                    }
                }
            },
            goToNextWeek() {
                if (this.selectedWeekIndex < this.weeks.length - 1) {
                    this.selectedWeekIndex++
                    const selectedWeek = this.weeks[this.selectedWeekIndex];
                    if (selectedWeek) {
                        this.setAndClearAnnouncement(`Moved to next week: ${selectedWeek.DisplayStartDate}`);
                    }
                }
            },
            getCalendarWeeks() {
                endpoints
                    .getCalendarWeeks({
                        SiteID: this.$store.state.PublicMenuModule.siteID,
                    })
                    .then((response) => {
                        response.forEach((w, $index) => {
                            w.index = $index
                        })

                        this.weeks = response
                        if (
                            this.selectedWeekIndex &&
                            this.weeks.filter((w) => w.StartDate === this.weeks[this.selectedWeekIndex].StartDate)[0]
                        ) {
                            this.searchMenuItems()
                        } else {
                            this.selectedWeek = this.weeks.filter((w) => w.IsCurrentWeek)[0]
                            let currentSelectedWeekIndex = this.selectedWeekIndex
                            this.selectedWeekIndex = this.selectedWeek.index
                            if (currentSelectedWeekIndex === this.selectedWeekIndex) {
                                this.searchMenuItems()
                            }
                        }
                    })
            },
            printPage() {
                window.print()
            },
        },
        mounted() {
            if (this.$store.state.PublicMenuModule.siteID) {
                this.getCalendarWeeks()
            }
        }
    }
</script>
<style>
    .app-calendar {
        display: grid;
        row-gap: 16px;
        column-gap: 16px;
        align-items: stretch;
    }

    .app-calendar-day {
        gap: 16px;
    }

    .app-calendar-header-row {
        display: contents;
    }

    .app-calendar-header-cell {
        font-size: 12px;
        font-weight: 600;
        text-align: center;
        background: #f6f6f7;
        padding: 12px 0;
        border-radius: 8px;
    }

    .app-calendar-day-title {
        font-size: 15px;
        font-weight: 700;
        color: #333;
        background-color: #f6f6f7;
        border-radius: 14px;
        padding: 16px;
        line-height: 125%;
        text-align: center;
    }


    .app-calendar-arrow {
        padding: 5px 8px;
        margin: 8px;
        font-size: 14px;
        border-radius: 8px;
        cursor: pointer;
        background-color: #C2E66E;
    }

    .app-calendar-arrow-disabled {
        opacity: 0.3;
        pointer-events: none;
    }

    .app-calendar-day {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .app-calendar-day-inner {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .app-calendar-category-row {
        display: contents;   
    }

    @media print {
        .app-calendar-category-row {
            page-break-inside: avoid;
        }
        
        .app-calendar-day-cell {
            page-break-inside: avoid;
            break-inside: avoid;
        }
    }

    .app-calendar-category-title {
        font-size: 14px;
        font-weight: 700;
        border-radius: 8px 8px 0 0;
        display: block;
        margin-bottom: 10px;
    }

    .app-calendar-day-cell {
        background: #f0f0f0;
        border-radius: 14px;
        min-height: 60px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 16px;
        box-sizing: border-box;
        text-align: left;
        position: relative;
    }

    .app-calendar-empty-day-cell {
        font-size: 14px;
        font-weight: 400;
        line-height: 150%;
        letter-spacing: 0%;
        background: #f0f0f0;
        border-radius: 14px;
        min-height: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 16px;
        box-sizing: border-box;
        text-align: center;
        position: relative;
    }

    .app-calendar-day-cell .app-calendar-empty-day-cell {
        background-color: unset;
        padding: 0;
    }

    .app-calendar-category-row:nth-of-type(2) .app-calendar-day-cell {
        background: #edffc4;
    }
    .app-calendar-category-row:nth-of-type(3) .app-calendar-day-cell {
        background: #ffedc9;
    }
    .app-calendar-category-row:nth-of-type(4) .app-calendar-day-cell {
        background: #f9f4f2;
    }
    .app-calendar-category-row:nth-of-type(5) .app-calendar-day-cell {
        background: #ffeedf;
    }
    .app-calendar-category-row:nth-of-type(n + 5) .app-calendar-day-cell {
        background: #f6f6f7;
    }

    .app-calendar-item-list {
        margin: 0px;
        padding-inline-start: 0px;
    }

    .app-calendar-item {
        font-size: 14px;
        font-weight: 400;
        line-height: 150%;
        letter-spacing: 0%;
    }

    .app-calendar-item:hover {
        color: #0000ff;
    }

    .app-calendar-item-text-only {
        font-size: 14px;
        font-weight: 400;
        line-height: 150%;
        letter-spacing: 0%;
    }

    .app-filter-container {
        align-items: center;
        margin-top: 28px;
        margin-bottom: 32px;
    }

    .app-calendar-empty-menu {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        grid-column: 1 / -1;
        min-height: 450px;
    }

    .app-calendar-empty-menu-img {
        height: 220px;
        width: 220px;
    }

    .app-calendar-empty-menu-text {
        font-size: 16px;
        font-weight: 400;
        color: #8a8c90;
    }

    .app-filter-item {
        max-width: 33.33%;
        flex: 1 1 33.33%;
    }

    .app-mobile-calendar {
        display: none !important;
    }

    @media (max-width: 576px) {
        .app-filter-item {
            margin-bottom: 10px;
        }

        .app-calendar {
            display: none !important;
        }

        .app-mobile-calendar {
            display: grid !important;
        }
    }

    @media (max-width: 1024px) {
        .app-date-picker {
            display: none !important;
        }
        .app-tablet-date-picker {
            display: flex !important;
        }
    }

    @media (min-width: 1024px) {
        .app-tablet-date-picker {
            display: none !important;
        }
    }
</style>
